import { KEYS } from 'game/constants/SceneConstants';
import { SceneBase } from '@jollywise/jollygoodgame';
import { ButtonSimple } from '@jollywise/jollygoodgame';

export class HowToPlay extends SceneBase {
  constructor() {
    super({ key: KEYS.HowToPlay, active: false });
  }

  init(config) {
    this._config = config.data;
  }

  create() {
    super.create();
    this.bg = this.add.image(0, 0, 'backgrounds', 'background_home').setOrigin(0);

    this.pages = [];
    while (this.pages.length < 5) {
      const page = this.add.image(
        2520,
        this.game.defaultHeight * 0.5,
        'howtoplay',
        `how_to_play_${this.pages.length + 1}`
      );
      this.pages.push(page);
    }

    this.pageCurrent = 0;
    this.pages[this.pageCurrent].x = 840;

    this.setupButtons();
  }

  setupButtons() {
    this.nextPageButton = new ButtonSimple(this, {
      x: 840 + 440,
      y: this.game.defaultHeight * 0.5,
      id: 'btn_next',
      costume: 'btn_next',
    }).setOrigin(0.5);

    this.nextPageButton.setInteractive({ useHandCursor: true });
    this.nextPageButton.on('pointerdown', this.nextPage, this);

    this.prevPageButton = new ButtonSimple(this, {
      x: 840 - 440,
      y: this.game.defaultHeight * 0.5,
      id: 'btn_prev',
      costume: 'btn_prev',
    }).setOrigin(0.5);

    this.prevPageButton.setInteractive({ useHandCursor: true });
    this.prevPageButton.on('pointerdown', this.prevPage, this);

    this.prevPageButton.disable();
    this.prevPageButton.alpha = 0;
  }

  buttonVisibilityCheck() {
    if (this.pageCurrent == this.pages.length - 1) {
      this.nextPageButton.disable();
      this.nextPageButton.alpha = 0;
    } else {
      this.nextPageButton.enable();
      this.nextPageButton.alpha = 1;
    }

    if (this.pageCurrent == 0) {
      this.prevPageButton.disable();
      this.prevPageButton.alpha = 0;
    } else {
      this.prevPageButton.enable();
      this.prevPageButton.alpha = 1;
    }
  }

  nextPage() {
    if (this.pageCurrent == this.pages.length - 1) {
      this.showPage(0, 1);
    } else this.showPage(this.pageCurrent + 1, 1);

    this.buttonVisibilityCheck();
  }

  prevPage() {
    if (this.pageCurrent == 0) {
      this.showPage(this.pages.length - 1, -1);
    } else this.showPage(this.pageCurrent - 1, -1);

    this.buttonVisibilityCheck();
  }

  showPage(page, direction) {
    if (this.tweening) return;
    this.tweening = true;
    const previousPage = this.pages[this.pageCurrent];
    const nextPage = this.pages[page];
    nextPage.x = 840 + 1680 * direction;
    this.tweens.add({
      targets: previousPage,
      x: 840 + 1680 * -direction,
      duration: 500,
      ease: Phaser.Math.Easing.Back.Out,
    });
    this.tweens.add({
      targets: nextPage,
      x: 840,
      duration: 500,
      ease: Phaser.Math.Easing.Back.Out,
      onComplete: () => (this.tweening = false),
    });
    this.pageCurrent = page;
  }

  shutdown() {
    super.shutdown();
  }
}
